/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import Icon from '../icon'
import { Box, Wrapper, ContainerIcon } from './styles'

type Props = {
  'data-qa'?: string
  defaultChecked?: boolean
  checked?: boolean
  disabled?: boolean
  onChange: (checkedValue: boolean) => void
  style?: object
  text?: string | JSX.Element
  theme?:
    | 'indeterminate'
    | 'negative'
    | 'preselected'
    | 'selected'
    | 'unselected'
}

const Checkbox: React.FC<Props> = (props: Props) => {
  const [isChecked, setIsChecked] = useState<boolean>(
    props.defaultChecked || false,
  )
  const theme = composeTheme(isChecked, props.theme)
  const iconName = composeIconName[theme]

  useEffect(() => {
    props.checked !== undefined && setIsChecked(props.checked)
  }, [props.checked])

  return (
    <Wrapper className={`${theme} ${props.disabled ? 'is-disabled' : ''}`}>
      <Box
        className={`${theme} ${props.disabled ? 'is-disabled' : ''}`}
        type="checkbox"
        checked={isChecked}
        onChange={() => {
          props.onChange(!isChecked)
          setIsChecked(!isChecked)
        }}
        data-qa={props['data-qa'] || `checkbox-${props.theme}`}
      ></Box>
      <ContainerIcon className="container-icon">
        {iconName && <Icon name={iconName} />}
      </ContainerIcon>

      {props.text}
    </Wrapper>
  )
}

export default Checkbox

Checkbox.defaultProps = {
  defaultChecked: false,
  disabled: false,
  theme: 'unselected',
}

export const composeIconName = Object.freeze({
  selected: 'check',
  preselected: 'check',
  indeterminate: 'remove',
})

export function composeTheme(isChecked: boolean, theme: string): string {
  return isChecked ? 'selected' : theme
}
